export default __webpack_public_path__ + "static/media/Group -11@2x.d2c0037c.png";